module.exports = __webpack_public_path__ + "img/Betting_text02_surething.4dbf8511.png";